module.exports = __webpack_public_path__ + "img/banner-bg.84cfd8f1.png";